module.exports = {"513230100":"壤柯镇","513230101":"南木达镇","513230102":"中壤塘镇","513230200":"蒲西乡","513230201":"宗科乡","513230202":"石里乡","513230203":"吾伊乡","513230204":"岗木达乡","513230205":"上杜柯乡","513230206":"茸木达乡","513230208":"尕多乡","513230210":"上壤塘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513230.json
// module id = 2408
// module chunks = 0